import React from "react";
import { useNavigate } from "react-router-dom";
import "./Banner.css";

const Banner = () => {
  const navigate = useNavigate();

  return (
    <section className="cta-banner" aria-labelledby="cta-heading">
      <div className="cta-inner">
        <p className="cta-eyebrow">Let’s talk growth</p>
        <h2 id="cta-heading">
          Ready to tune your <span>growth engine?</span>
        </h2>
        <p className="cta-copy">
          Book a short strategy call and we’ll review where you are today across
          website, SEO, paid, and CRM—and outline 2–3 practical moves you can
          make in the next 30 days.
        </p>

        <div className="cta-footer">
          <button className="cta-btn" onClick={() => navigate("/contact")}>
            Book a Strategy Call
          </button>
          <p className="cta-note">
            No pressure, no hard sell—just a focused conversation about what’s
            working, what isn’t, and what to try next.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Banner;
